// removed by extract-text-webpack-plugin
module.exports = {"root":"ExpandableBox__root__ObMbR","button":"ExpandableBox__button__3jJyW","buttonExpanded":"ExpandableBox__buttonExpanded__8q9IL","iconArrow":"ExpandableBox__iconArrow__2yKQI","iconArrowExpanded":"ExpandableBox__iconArrowExpanded__8ynIn","content":"ExpandableBox__content__2IyUF","contentExpanded":"ExpandableBox__contentExpanded__1TMB3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpandableBox/ExpandableBox.css
// module id = 1767
// module chunks = 0